<template>
  <div class="rotation-card"
       @click="change(rotation)"
       :class="{'active': rotation === value}"
  >
    <div class="selection">
      <div class="select"
           :class="{'selected': rotation === value}"
      >
        <img :src="getImage('check-motor.svg')">
      </div>
    </div>
    <div class="rotation-image">
      <span class="name" v-text="translate(rotation.name)"></span>
      <img :src="getFromStorage(rotation.image)">
      <span class="price" v-text="formatPrice(rotation.price / 100)"></span>
    </div>
  </div>
</template>

<script>
import getBuildMixin from "@/mixins/getBuildMixin";
import { getFromStorage } from "@/helpers/backendStorage";

export default {
  name: "RotationCard",

  mixins: [getBuildMixin],

  props: {
    rotation: {
      type: Object,
    },
    value: {
      type: Object,
    }
  },

  methods: {
    getFromStorage,
    change(newValue) {
      this.$emit('change', newValue);
      this.$emit('input', newValue);
    },
  }
}
</script>

<style scoped lang="scss">
.rotation-card {
  margin: 0 19px 15px 0;
  background-color: #FAFAFA;
  max-width: 320px;
  max-height: 85px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: row;
  cursor: pointer;
  transition: all ease 0.3s;
  user-select: none;

  &.active {
    background-color: rgba(113, 188, 3, 0.1);
  }

  &:hover {
    transform: scale(1.03);
  }

  .selection {
    max-width: 44px;
    display: flex;
    align-items: center;
    padding: 33px 13px;

    .select {
      cursor: pointer;
      border-radius: 50%;
      border: 1px solid #707070;
      width: 17px;
      height: 17px;
      transition: all ease 0.3s;

      img {
        display: none;
      }

      &.selected {
        border: none;

        img {
          display: block;
          width: 17px;
          height: 17px;
        }
      }
    }
  }

  .rotation-image {
    background-color: #FAFAFA;
    padding-top: 15px;
    max-width: 270px;
    max-height: 85px;
    position: relative;
    display: flex;
    justify-content: center;

    .name {
      position: absolute;
      margin-right: 50px;
      font-family: neue-haas-grotesk-text, sans-serif;
      font-size: 12px;
    }

    .price {
      position: absolute;
      right: 4px;
      top: 1px;
      font-family: neue-haas-grotesk-display, sans-serif;
      font-size: 12px;
      color: #3DB0C7;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
